import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CheckboxComponent } from '../../../../ui/checkbox/checkbox.component';
import { MODAL_DATA } from '../../../../ui/modal/modal-data.token';

@Component({
	selector: 'app-add-property-tax-confirmation-modal',
	imports: [CommonModule, FormsModule, CheckboxComponent],
	templateUrl: './add-property-tax-confirmation-modal.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddPropertyTaxConfirmationModalComponent {
	dontAskAgain = false;

	constructor(
		@Inject(MODAL_DATA) public data: { title: string; message: string },
	) {}

	setDontAskAgain(value: boolean): void {
		this.dontAskAgain = value;
		if (value) {
			localStorage.setItem('skipPropertyTaxConfirmation', 'true');
		}
	}
}
